/**
 * The open/close lifecycle of an exported dispatch dialog (batch 8 T12c1, #3033).
 *
 * A dialog that is closed and opened again is a NEW dialog: nothing it showed, held or was waiting for before (a review, a confirmation,
 * an error, a success, a request still on its way) may come back. The session number changes on every opening, and the dialog body is
 * keyed by it, so the old body unmounts and whatever it was waiting for has nowhere to land.
 */

import { useState } from 'react';

export function useOpenSession(open: boolean): number {
  const [state, setState] = useState({ open, session: 0 });
  if (state.open !== open) {
    // Adjusted while rendering, so the very render that sees the opening already uses the new session.
    setState({ open, session: open ? state.session + 1 : state.session });
    return open ? state.session + 1 : state.session;
  }
  return state.session;
}
